import React, { useCallback, useEffect, useRef } from "react";
import "../assets/styles/pages/loading.css";

type LoadingProps = {
    onDone: () => void;
};

function Loading({ onDone }: LoadingProps) {
    const doneRef = useRef(false);
    const finish = useCallback(() => {
        if (doneRef.current) return;
        doneRef.current = true;
        onDone();
    }, [onDone]);

    useEffect(() => {
        const fallback = window.setTimeout(finish, 3200);
        return () => window.clearTimeout(fallback);
    }, [finish]);

    return (
        <div
            className="loading-screen"
            role="status"
            aria-live="polite"
            aria-busy="true"
            onAnimationEnd={(e) => {
                if (e.animationName === "loading-screen-out") finish();
            }}
        >
            <div className="loading-screen__inner">
                <p className="loading-screen__line loading-screen__line--muted">Portfolio</p>
                <p className="loading-screen__line loading-screen__line--name">Anton Korolov</p>
            </div>
        </div>
    );
}

export default Loading;
